enum Interactions {
  CtaUrlClick = 'ctaUrlClick',
  CtaUrl2Click = 'ctaUrl2Click'
};

export default Interactions;
